import { ReactNode } from 'react'
import { useAuth } from '@/auth/auth-context'
import { AdminGuard } from '@/components/guards/admin-guard'
import { LoadingContainer } from './loading'
import NavLogoButton from './nav-logo-button'
import ProfileDropdown from './nav-profile-dropdown'
import { SettingSidebar } from './setting-sidebar'
import { Sidebar } from './sidebar'
import Footer from './footer'

export default function Container({ children }: { children: ReactNode }) {
  return <div className="p-8">{children}</div>
}

export function SidebarContainer({ children }: { children: ReactNode }) {
  return <div className="lg:py-6 lg:px-6">{children}</div>
}

export function ContainerWithSidebar({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-h-screen">
        <main role="main" className="flex-1">
          <div className="px-4 pt-16 pb-4 lg:px-6 lg:py-6">{children}</div>
        </main>
      </div>
    </div>
  )
}

export function ContainerWithSidebarAndNoTopbar({
  children,
}: {
  children: ReactNode
}) {
  return (
    <AdminGuard>
      <div className="min-h-screen flex justify-center">
        <div className="flex flex-col md:flex-row w-full max-w-5xl">
          <SettingSidebar />
          <div className="flex-1 flex flex-col overflow-auto">
            <main role="main" className="flex-1">
              <div className="px-4 py-4 md:px-8 md:py-6">{children}</div>
            </main>
          </div>
        </div>
      </div>
    </AdminGuard>
  )
}

export function HomeContainer({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingContainer />
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="container mx-auto py-6 px-6 flex-1 flex flex-col">
        <div className="flex items-start justify-between mb-4">
          <NavLogoButton />
          {user && (
            <div className="flex items-center justify-end">
              <ProfileDropdown user={user} />
            </div>
          )}
        </div>
        <div className="flex-1">{children}</div>
        <Footer />
      </div>
    </div>
  )
}
